export const lang = {
  homepage: '主页',
  download: "下载",
  downloadMsg: "建议您使用chrome浏览器进行视频连麦",
  loginPage1: "教师中心",
  loginPage2: "您还没有账号？",
  loginPage3: "注册",
  loginPage4: "",
  loginPage5: "忘记密码?",
  loginPage6: "找回密码",
  loginPage7: "登录",
  loginPage8: "邮箱或手机号",
  loginPage9: "密码",
  loginPage10: "请填写邮箱地址或手机号",
  loginPage11: "请输入长度6-14位的密码",
  loginPage12: "发送验证码",
  loginPage13: "验证码",
  loginPage14: "确认密码",
  loginPage15: "提交",
  loginPage16: "已经注册了账户？",
  loginPage17: "请输入正确的验证码",
  loginPage18: "请输入密码",
  loginPage19: "请输入确认密码",
  loginPage20: "两次输入的密码不一致",
  loginPage21: "验证码已发送到您的邮箱",
  loginPage22: "修改成功",
  loginPage23: "请求服务器失败，请稍后再试",
  loginPage24: "帐户或密码不正确",
  loginPage25: "注册成功",
  loginPage26: "请填写正确验证码",
  loginPage27: "获取验证码",
  loginPage28: "获取验证码",
  loginPage29: "亲爱的老师:",
  loginPage30: "我们已向您发送电子邮件，请在电子邮件中输入验证码以激活您的帐户。",
  loginPage31: "如果您没有收到电子邮件，请检查您的垃圾邮件。",
  steps1: "注册账户",
  steps2: "完善信息",
  steps3: "提交审核",
  steps4: "审核成功",
  steps5: "审核失败",
  userPage1: "姓名",
  userPage2: "出生日期",
  userPage3: "请选择时间",
  userPage4: "性别",
  userPage5: "男",
  userPage6: "女",
  userPage7: "联系电话",
  userPage8: "选择区号",
  userPage9: "微信",
  userPage10: "国家",
  userPage11: "学历",
  userPage12: "请选择国家",
  userPage13: "请选择学历",
  userPage14: "教学经验",
  userPage15: "企业名称",
  userPage16: "职位",
  userPage17: "工作时间",
  userPage18: "每周小时数",
  userPage19: "自我介绍",
  userPage20: "请把必填项填满",
  userPage21: "开始时间",
  userPage22: "结束时间",
  userPage23: "请输入姓名",
  userPage24: "请选择出生日期",
  userPage25: "请选择性别",
  userPage26: "请选择区号",
  userPage27: "请输入您的微信号",
  userPage28: "请选择国家",
  userPage29: "请选择学历",
  userPage30: "请输入自我介绍，限制（4-500字）",
  userPage31: "请输入手机号码",
  userPage32: "每周小时数是一个数值",
  userPage34: "请输入数值",
  userPage35: "请输入您的自我介绍",
  userPage36: "高中",
  userPage37: "本科",
  userPage38: "硕士",
  userPage39: "博士",
  userPage40: "海外留学生",
  userPage41: "以上都不是",
  userPage42: "稍后我们的面试官将跟您取得联系，请耐心等待，谢谢",
  userPage43: "审核中",
  userPage44: "恭喜你，你通过了我们的审核。很高兴您加入bingotalk的大家庭。",
  userPage45: "进入教师中心",
  userPage46: "你没有通过我们的审核，请重新提交审核材料。",
  userPage47: "重新提交审核",
  userPage48: "激活成功",
  userPage49: "5秒后将跳转到教师中心",
  userPage50: "激活失败",
  userPage51: "请重新激活您的邮箱",
  userPage52: "发送激活电子邮件",
  userPage53: "发送成功",
  userPage54: "缺少邮件地址",
  userPage55: "姓名",
  userPage56: "年龄",
  userPage57: "国籍",
  userPage58: "自我介绍",
  userPage59: "更改密码",
  userPage60: "停止或恢复合作",
  userPage61: "更换",
  userPage62: "修改",
  userPage63: "上传",
  userPage64: "取消",
  userPage65: "上传头像",
  userPage66: "头像",
  userPage67: "自我介绍视频",
  userPage68: "播放",
  userPage69: "基本信息",
  userPage70: "请发送申请至邮箱",
  userPage71: "复制",
  userPage72: "我知道了",
  userPage73: "更改密码",
  userPage74: "旧密码",
  userPage75: "新密码",
  userPage76: "确认密码",
  userPage77: "上传视频成功",
  userPage78: "请上传视频格式为mp4",
  userPage79: "请上传的视频不能大于100MB",
  userPage80: "请上传不大于5M的JPG、PNG图片",
  userPage81: "上传头像成功",
  userPage82: "请输入旧密码",
  userPage83: "新密码 : 长度6-14个字符",
  userPage84: "请输入新密码",
  userPage85: "确认密码 : 长度6-14个字符",
  userPage86: "新密码不能和旧密码相同",
  userPage87: "请输入您的姓名",
  userPage88: "密码修改成功",
  userPage89: "复制成功",
  userPage90: "复制失败",
  userPage91: "关闭",
  userPage92: "设置上课时间",
  userPage93: "完善信息",
  userPage94: "随便看看",
  demoPage1: "首先，请选择您方便的上课时间",
  demoPage2: "下一步",
  demoPage3: "添加",
  demoPage4: "现在，您可以添加一个方便的上课时间。",
  demoPage5: "系统将自动保存为预备课",
  demoPage6: "保存计划",
  demoPage7: "添加时间后，单击按钮保存计划",
  demoPage8: "我知道了",
  demoPage9: "跳过",
  demoPage10: "这里可以切换中英文显示哦～",
  demoPage11: "设置自己的上课时间进行约课吧",
  demoPage12: "这里可以快速看到自己24小时内的课程情况",
  demoPage13: "英文",
  demoPage14: "完成",
  demoPage15: "教师姓名",
  headerPage1: '退出',
  silderPage1: '主页',
  silderPage2: '预约',
  silderPage3: '教室',
  silderPage4: '账户',
  silderPage5: '薪资',
  silderPage6: '评分',
  silderPage7: '使用帮助',
  silderPage8: '点击下载',
  homePage1: "即将上课",
  homePage2: "暂无课程安排",
  homePage3: "1对1",
  homePage4: "公开课",
  homePage5: "1对多",
  homePage6: "约课（1V1&1Vn）",
  homePage7: "已约课（1v1）",
  homePage8: "进入",
  homePage9: "最近一周课程表",
  homePage10: "选择时间",
  homePage11: "本地时间",
  homePage12: "北京时间",
  homePage13: "已预约",
  homePage14: "孩子",
  homePage15: "年龄",
  homePage16: "等级",
  homePage17: "课程",
  homePage18: "时间",
  homePage19: "详情",
  homePage20: "星期一",
  homePage21: "星期二",
  homePage22: "星期三",
  homePage23: "星期四",
  homePage24: "星期五",
  homePage25: "星期六",
  homePage26: "星期天",
  homePage27: "没有预约",
  homePage28: "已完成",
  homePage29: "审核中",
  homePage30: "教师旷课",
  homePage31: "学生旷课",
  homePage32: "审核失败",
  homePage33: "准备课程",
  homePage34: "试听课",
  homePage35: "已约课（1Vn）",
  bookPage1: "课程表",
  bookPage2: "下周",
  bookPage3: "本周",
  bookPage4: "上周",
  bookPage5: "保存课程表",
  bookPage6: "时区",
  bookPage7: "选择",
  bookPage8: "添加临时课程成功",
  bookPage9: "点击保存课程表按钮来进行保存",
  bookPage10: "取消临时课程成功",
  bookPage11: "保存课程表成功",
  bookPage12: "有课，可抢单",
  bookPage13: "有{num}个时间未安排老师，开放时间立即抢单",
  bookPage14: "立即开放",
  classRoom1: "返回",
  classRoom2: "上一页",
  classRoom3: "下一页",
  classRoom4: "当前页",
  classRoom5: "暂无数据",
  classRoom6: "笔记",
  classRoom7: "渲染失败, 当前页 1",
  classRoom8: "加载PDF失败, 请刷新页面",
  classRoom9: "备注笔记成功",
  classRoom10: "课程类型",
  classRoom11: "筛选",
  classRoom12: "只显示24小时内已完成的课程",
  classRoom13: "即将开始",
  classRoom14: "正在上课",
  classRoom15: "通过",
  classRoom16: "审核中",
  classRoom17: "教师旷课",
  classRoom18: "学生旷课",
  classRoom19: "未通过",
  classRoom20: "回放",
  classRoom21: "备课",
  classRoom22: "学生信息",
  classRoom23: "暂无查询数据",
  classRoom24: "全部",
  classRoom25: "评价",
  classRoom26: "最近评价",
  classRoom27: "暂无评价",
  classRoom28: "糟糕",
  classRoom29: "一般",
  classRoom30: "好",
  classRoom31: "很好",
  classRoom32: "非常好",
  classRoom33: "学生评分",
  classRoom34: "平台评分",
  classRoom35: "请输入评论",
  classRoom36: "评分成功",
  classRoom37: "课时费：",
  classRoom38: "系统备注",
  homePage: '老师主页',
  openingTime: '开放时间',
  pendingCourse: '待上课程：',
  openClass: '公开课',
  miniClass: '小班课',
  recentCourse: '最近课程',
  pendingCourses: '待上课程',
  takenCourse: '已上课程',
  noPendingCourses1: '暂无待上课程',
  noPendingCourses2: '请开放更多时间让更多学生看到您',
  classInfo: '上课信息',
  payment: '报酬：',
  time: '时间：',
  course: '课程：',
  unit: '单元：',
  notes: '备注：',
  nothingYet: '暂无',
  lessonPreview: '课件预览',
  localTime: '当地时间：',
  BeijingTime: '北京时间：',
  morning: '上午AM',
  afternoon: '下午PM',
  night: '晚上PM',
  allOpen: '全部开放',
  cancelAll: '取消全部',
  personalInfo: '个人信息',
  age: '年龄：',
  nationality: '国籍：',
  selfIintroduction: '自我介绍',
  selfIntroductionVideo: '自我介绍视频',
  change: '更换',
  cooperationTip1: '停止或恢复合作请发送申请至邮箱',
  cooperationTip2: 't.report@bingotalk.cn',
  unbindling: '解绑账号',
  unbindlingTip: '确定要解绑此账号？',
  cancel: '取 消',
  unbind: '解 绑',
  ordered1v1: '1v1 已约',
  orderedOpen: '公开课 已约',
  ordered1vN: '1vN 已约',
  classeBegin: '已预约',
  addTime: "添加课程成功",
  cancelTime: "取消课程成功",
  classURL: "上课地址：",
  copyLink: "复制",
  copySuccess: "复制成功，请在PC浏览器中打开！",
  courseTitle: "课程详情",
  homeTitle: "教师主页",
  meTitle: "个人信息",
  bookingTitle: "开放时间",
  loadMore: "上滑加载更多",
  noMore: "没有更多了",
  wrongTimezone: "时区错误？",
  timezoneTip: "在网页端执行开放时间即可矫正您的时区",
  selectTZ: "请选择时区",
  TZ: "时区",
  confirm: "确认",
  select: "请选择",
  tzNullTip: "请选择时区",
  qrTipLine1: "微信扫一扫，",
  qrTipLine2: "公众号开放时间更方便哦",
  browserTipTitle: "温馨提示",
  browserTip: "系统检测到您没有使用 Chrome（谷歌浏览器）访问我们的网站。使用其他浏览器可能会影响您的上课体验，因此我们强烈建议您下载并使用谷歌浏览器，从而获得更好的体验。",
  downloadChrome: "下载谷歌浏览器",
  ChromeURL: "https://www.google.cn/chrome/index.html",
  backupBtn: "下载链接失效？",
  recommendTip: "可抢单"
}

export const msg = {

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js